import { createReducer } from '@reduxjs/toolkit'

import { InternalApiUsageActions } from './actions'
import type { ApiUsageState } from './types'

const initial: ApiUsageState = {
  data: null,
  error: false,
}

export const apiUsageReducer = createReducer(initial, (builder) => {
  builder
    .addCase(InternalApiUsageActions.set, (state, { payload }) => ({
      ...state,
      data: payload,
      error: false,
    }))
    .addCase(InternalApiUsageActions.setError, (state, { payload }) => ({
      ...state,
      error: payload,
    }))
})
